// extracted by mini-css-extract-plugin
export default {"menuWrapper":"ThreeDotMenu_menuWrapper__xUMWc","iconButton":"ThreeDotMenu_iconButton__5Qv8G","dropdown":"ThreeDotMenu_dropdown__4i4sU","menuItem":"ThreeDotMenu_menuItem__CkJxa"};